import { repository } from '@woc/woc-repository'
import { RecoType, RecoCapabilities } from '@/model/reco'

export const recoTypeSearchRepository = repository.create({
  entity: 'recoTypeSearch',
  url: 'reco/types',
  allow: 'l',
  factory: data => new RecoType(data)
})

export const recoCapabilitiesRepository = repository.create({
  entity: 'recoCapabilities',
  url: 'reco/capabilities',
  allow: 'r',
  childResource: true,
  factory: data => new RecoCapabilities(data)
})

export const recoRecommendationRepository = repository.create({
  entity: 'recoRecommendation',
  url: 'reco/search/:searchId/recommendations/:typeId',
  allow: 'r',
  childResource: true
})

export const recoCategoryRepository = repository.create({
  entity: 'recoCategory',
  url: 'reco/categories',
  allow: 'l'
})

export const recoBrandRepository = repository.create({
  entity: 'recoBrand',
  url: 'reco/categories/:categoryId/brands',
  allow: 'l'
})

export const recoModelRepository = repository.create({
  entity: 'recoModel',
  url: 'reco/categories/:categoryId/brands/:brandId/models',
  allow: 'l'
})

export const recoTypeRepository = repository.create({
  entity: 'recoType',
  url: 'reco/categories/:categoryId/brands/:brandId/models/:modelId/types',
  allow: 'l'
})

export default repository.asModule(recoTypeSearchRepository, recoCapabilitiesRepository, recoRecommendationRepository,
  recoCategoryRepository, recoBrandRepository, recoModelRepository, recoTypeRepository)
